import React from 'react';
import PropTypes from 'prop-types';
import './ToggleSelect.css';

function ToggleSelect({ onClick = () => {}, isSelected }) {
  return (
    <span
      onClick={() => {
        onClick(!isSelected);
      }}
      className={isSelected ? 'toggle-select selected' : 'toggle-select'}
    >
      <span className={'plusOrMinus' + (isSelected ? ' minus' : '')}>
        -
      </span>
    </span>
  );
}

ToggleSelect.defaultProps = {
  onClick: undefined,
  isSelected: false
};

ToggleSelect.propTypes = {
  onClick: PropTypes.func,
  isSelected: PropTypes.bool
};

export default ToggleSelect;
